import {
  AsyncDataPreset,
  AsyncDataTransformer,
  useAsyncData,
} from '../../api/asyncData';
import { CategoryParent } from '../../constants';
import { Option } from '../../types';

export const useCategoriesOptions = (
  parent: CategoryParent,
): [Option<string>[], boolean] => {
  const { data, isLoading } = useAsyncData({
    preset: AsyncDataPreset.Categories,
    parent,
    transformer: AsyncDataTransformer.Options,
  });

  return [data, isLoading];
};
